import { Alert, Box, Button } from "@mui/material"
import React from "react"

import { translationsContext } from "context/translations"


/**
 * Shown when a GraphQL query could not be loaded at all — an aborted fetch, a
 * dropped connection, a non-JSON response. Distinct from a backend-reported
 * GraphQL error, which the forms render inline via common_errors.
 *
 * The two keys carry English only in scripts/translations.xlsx; the other five
 * languages are blank on purpose, and `useTranslations` falls back to `.en`, so
 * this reads as English everywhere until a translator fills the columns in. No
 * code change is needed when they do.
 */
export function LoadFailure({onRetry}: {onRetry: () => void}) {
    const t = React.useContext(translationsContext)

    return (
        <Box
            data-testid="load-failure"
            sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 'calc(50vh - 100px)'}}
        >
            <Alert severity="error">{t('common__err__load_failed')}</Alert>
            <Button data-testid="load-retry" variant="contained" onClick={onRetry}>
                {t('common__button__retry')}
            </Button>
        </Box>
    )
}
